export default {
    total(state) {
        return state.total
    },
    sites(state) {
        return state.sites
    }
}
